if (!customElements.get('nipponika-pairings')) {
  customElements.define('nipponika-pairings', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.buttons = [...this.querySelectorAll('button[data-items]')];
      this.error = this.querySelector('.pairings__error');
      this.buttons.forEach((button) => {
        button.disabled = button.dataset.available !== 'true';
        button.addEventListener('click', () => this.addSelection(button));
      });
    }

    async addSelection(button) {
      if (this.busy || button.disabled) return;
      this.busy = true;
      this.error.hidden = true;
      this.buttons.forEach((item) => { item.disabled = true; });
      const originalLabel = button.textContent;
      button.textContent = 'Adding…';
      button.setAttribute('aria-busy', 'true');
      const root = window.Shopify?.routes?.root || '/';
      let errorMessage = 'We could not update your cart. Please try again or choose the pieces individually.';
      try {
        const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('We could not read your cart. Please try again.');
        const cart = await cartResponse.json();
        // Keep existing selections, including pieces already present in the cart.
        const items = JSON.parse(button.dataset.items).filter((item) =>
          !cart.items.some((line) => line.variant_id === item.id && line.quantity > 0)
        );
        if (items.length) {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!response.ok) {
            errorMessage = 'Some pieces could not be added. Please review your cart or choose the pieces individually.';
            throw new Error('Cart update failed');
          }
        }
        window.location.assign(`${root}cart`);
      } catch {
        this.error.querySelector('[data-error-message]').textContent = errorMessage;
        this.error.hidden = false;
        this.error.focus();
        this.buttons.forEach((item) => { item.disabled = item.dataset.available !== 'true'; });
        button.textContent = originalLabel;
        button.removeAttribute('aria-busy');
        this.busy = false;
      }
    }
  });
}
